export enum DayType {
  BusinessDay = 'BUSINESS_DAY',
  CalendarDay = 'CALENDAR_DAY',
}

export type RelativeTime =
  | {
      minutesBeforeEncounterStartTime: number;
      minutesAfterFormSetCreated: null;
    }
  | {
      minutesBeforeEncounterStartTime: null;
      minutesAfterFormSetCreated: number;
    };

export type Rule = RelativeTime & {
  validStartTime: string;
  validEndTime: string;
  dayType: DayType;
};

export type UpsertRule = Omit<Rule, 'dayType'> & {
  dayType?: DayType;
};
